import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class AtSpoke extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <g id="atspoke" transform="translate(0.000000, 3.800000)">
          <path d="M10.0470827,16.0064 C9.950272,15.3870933 9.89918933,14.7613867 9.894272,14.1345067 C9.092032,15.3570133 7.64036267,16.4266667 5.310048,16.4266667 C1.986496,16.4266667 0,14.1728 0,11.76608 C0,9.01546667 2.02469333,7.48746667 4.62242133,7.10538667 L8.44260267,6.53239467 C9.32123733,6.417792 9.62685867,5.95937067 9.62685867,5.424544 C9.62685867,4.31669333 8.78642133,3.39984 7.02913067,3.39984 C5.19544533,3.39984 4.20219733,4.54589867 4.08759467,5.92116267 L0.382018133,5.11892267 C0.6494304,2.71221333 2.86514133,-0.000117333333 7.02913067,-0.000117333333 C11.95712,-0.000117333333 13.75264,2.78861867 13.75264,5.88296533 L13.75264,13.48512 C13.74848,14.304 13.8123733,15.1218133 13.94368,15.9300267 L10.0470827,15.9300267 L10.0470827,16.0064 Z M9.58865067,9.05376 L6.07409067,9.58858667 C5.00443733,9.74133333 4.164,10.3525333 4.164,11.5368533 C4.164,12.4536533 4.81342933,13.3322667 6.18869333,13.3322667 C7.945984,13.3322667 9.58865067,12.49184 9.58865067,9.74133333 L9.58865067,9.05376 Z"></path>
          <path d="M19.79776,16.4266667 C22.1186133,16.4266667 24,14.54528 24,12.2244267 C24,9.90368 22.1186133,8.02229333 19.79776,8.02229333 C17.4770133,8.02229333 15.5956267,9.90368 15.5956267,12.2244267 C15.5956267,14.54528 17.4770133,16.4266667 19.79776,16.4266667 Z"></path>
        </g>
      </svg>
    );
  }
}

export default AtSpoke;
